<template lang="html">
    <div class="pb-5">
        <div class="container container-small" v-if="profile">
            <Heading class="py-4" :title="$t('edit_profile_title')"></Heading>
            <BillingProfile :mode="'edit'" v-on:input="updateProfileFromComponent($event)" @resetErrors="resetErrorMsgs" :errorMsgs="errorMsgs" v-model="profile"></BillingProfile>
            <div class="text-center pt-4 pb-4">
                <button class="btn btn-purple w-100" @click="updateProfile()">{{ $t('btn_save') }}</button>
            </div>
            <div class="pb-4 text-right">
                <a class="text-danger pointer" v-on:click="remove(profile.id)"><i class="fa fa-trash my-auto" aria-hidden="true"></i> {{ $t('profiles_delete_profile') }}</a>
            </div>
        </div>
    </div>
</template>

<script>

import Heading from './../snippets/Heading.vue'
import BillingProfile from './../snippets/BillingProfile.vue'

import { mapActions, mapState } from 'vuex'

export default {
    name: 'EditProfile',
    components: {
        Heading,
        BillingProfile
    },
    data: function() {
        return {
            profile: null,

            errorMsgs: {
                first_name: '',
                last_name: '',
                address: '',
                country: '',
                county: '',
                company: '',
                j_code: '',
                fiscal_code: ''
            },

            loading: false,
        }
    },
    props: ['id'],
    computed: {
    },
    created() {
        this.init();
    },
    watch: {
    },
    methods: {
        ...mapActions('profiles', {
            actionUpdateProfile: 'updateProfile',
            actionGetProfile: 'getProfile',
            actionDeleteProfile: 'deleteProfile',
            actionClearProfile: 'clearProfile',
            setManualProfileCompletion: 'setManualProfileCompletion'
        }),

        updateProfileFromComponent(event) {
            this.profile = event.profile;
        },

        resetErrorMsgs() {
            this.errorMsgs = {
                first_name: '',
                last_name: '',
                address: '',
                country: '',
                county: '',
                company: '',
                j_code: '',
                fiscal_code: ''
            };
        },

        async init() {
            try {
                this.loading = true;

                if(this.$store.getters['profiles/getProfile'] != null && this.$store.getters['profiles/getProfile'].id == this.$route.params.id) {
                    this.profile = this.$store.getters['profiles/getProfile'];
                    this.loading = false;
                }
                else {
                    let response = await this.actionGetProfile(this.id);
                    this.profile = response.data.profile;
                    this.loading = false;
                }
            }
            catch (err) {
                if(err.response) {
                    this.$dialog.alert({
                        'message': err.response.data.error.error_msg,
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                }
            }
        },

        validate()
        {
            this.clearErrors(this.errorMsgs);

            var ok = true;

            var mandatoryText = this.$t('mandatory');

            if(this.profile.billing_type == 'pj') {

                if(!this.profile.validated_cui) {
                    ok = false;
                }

                if(!this.profile.fiscal_code) {
                    ok = false;
                    this.errorMsgs.fiscal_code = mandatoryText;
                }

                if(!this.profile.company) {
                    ok = false;
                    this.errorMsgs.company = mandatoryText;
                }

                if(!this.profile.j_code) {
                    ok = false;
                    this.errorMsgs.j_code = mandatoryText;
                }

                if(!this.profile.city) {
                    ok = false;
                    this.errorMsgs.city = mandatoryText;
                }

                if(!this.profile.address) {
                    ok = false;
                    this.errorMsgs.address = mandatoryText;
                }

            }

            if(this.profile.billing_type == 'pf') {

                if(!this.profile.first_name) {
                    ok = false;
                    this.errorMsgs.first_name = mandatoryText;
                }

                if(!this.profile.last_name) {
                    ok = false;
                    this.errorMsgs.last_name = mandatoryText;
                }

                if(!this.profile.county && this.profile.country == 1) {
                    ok = false;
                    this.errorMsgs.county = mandatoryText;
                }

                if(!this.profile.city) {
                    ok = false;
                    this.errorMsgs.city = mandatoryText;
                }

                // if(!this.profile.address) {
                //     ok = false;
                //     this.errorMsgs.address = mandatoryText;
                // }
            }

            return ok;
        },

        async updateProfile() {

            if(!this.validate()) return false;

            this.loading = true;

            try {
                this.profile.id = this.id;
                let response = await this.actionUpdateProfile(this.profile);
                this.actionClearProfile();
                this.setManualProfileCompletion(false);

                this.$router.go(-1);

            } catch (err) {
                this.loading = false;

                if(err.response) {
                    this.$dialog.alert({
                        'message': err.response.data.error.error_msg,
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                }
            }
        },

        remove() {
            this.profile = this.$store.getters['profiles/getProfile'];

            this.$dialog.confirm({
                title: this.$t('edit_profile_delete_profile_title'),
                message: this.$t('edit_profile_delete_profile'),
                cancelButtonText: this.$t('no'),
                confirmButtonText: this.$t('yes'),
                beforeClose: this.doRemoveProfile
            })
            .then(() => {
              this.$router.push({ name: 'profiles' });
                console.log(this.$router)
            })
            .catch(() => {
                // on cancel
            });
        },

        doRemoveProfile(action, done) {
            if(action == 'confirm') {
                this.actionDeleteProfile(this.profile.id).then(async response => {
                    done();
                }).catch(err => {
                    if(err.response) {
                      this.$dialog.alert({
                            'message': err.response.data.error.error_msg,
                            'confirmButtonText': this.$t('btn_i_understand')
                        });
                    }
                    done();
                });
            }
            else {
                done();
            }
        }
    }
}

</script>

<style lang="scss" scoped>

$lightgrey: lightgrey;
$green: #59af54;

.ancillary {
    color: #DCCCCD;
}

</style>
